// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"11":"CurrencySelectionModal","380":"LocaleSelectionModal","688":"LanguageSelectionModal","717":"LocaleMessagePopover","813":"LocaleMessageModal"}[chunkId] + "." + {"11":"d9080085080b99f19676","380":"c463812557a08ba2b270","688":"920050667d912d1d65cf","717":"a641d53162020fe1dbf8","813":"0861db76c29eed621817"}[chunkId] + ".js";
};